function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import find from 'ramda/src/find';
import pathOr from 'ramda/src/pathOr';
import propEq from 'ramda/src/propEq';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { validateNumbers } from 'invision-core/src/utilities/input.helper';
import { fetchCodeTypes, fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CurrentBusinessUnitHasSubtenants } from '../../../reducers/selectors/subtenant.selectors';
import { CurrentStepSelector, CreatedCustomerSelector } from '../../../reducers/selectors/new.connect.wizard.selectors';
import CustomerCareLocaleKeys from '../../../locales/keys';
import { getErrorLookupObject } from '../create.customer.constants';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { SessionSelectors } from 'invision-core';
import { LanguagesForCurrentBusinessUnitSelector, MetadataCodeLoadedSelector, MetadataCodeTypeSelector, MetadataOptionsForCodeValuesSelector, MetadataOptionsForCodeValuesWithoutPlaceholderSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CurrentBusinessUnitSelector, IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { ActiveSubtenantsSelector, SubtenantsLoadedSelector } from 'invision-core/src/components/subtenants/subtenants.selectors';
import { CreateEditCustomerSelector, CreateCountryCurrencyValueOptions, DefaultCountryCurrencySelector, HasConvergentBillerIdSelector, IsEditCustomerHierarchyRootOrNotInHierarchySelector, SelectedCustomerCategorySelector, SelectedCustomerHomeCountrySelector, SelectedCustomerIsDateOfBirthRequired, SubtenantOptionsSelector } from '../../../reducers/selectors/customer.selectors';
import { ContactMethodOptionsSelector, CustomerTypeFilteredSelector, DefaultCustomerTypeSelector, HomeCountriesStatesSelector, SubscriberIdentificationsSelector, SubscriberTypeFilterByUserRole, TaxAssociationCodesSelector, TaxExemptionTypeCodesSelector, TaxLevelCodesSelector } from '../../createCustomerPopup/customer.form.dropdown.selectors';
import { searchSubtenants, setCustomerCategory, fetchSubtenantMetadata } from '../../../reducers/actions/customer.actions';
import { ACCEPTING_FOR, CONSENT_TYPES, CUSTOMER_CATEGORY, NO_SUBTENANTS } from '../../createCustomerPopup/create.customer.popup.constants';
import * as taxModelHelper from '../tax.model.helper';
import { StatesByCountrySelector } from '../../wizards/newConnectWizard/new.connect.wizard.selectors';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import { BillingConfigurationLoadedSelector } from 'invision-core/src/components/metadata/billingConfiguration/billing.configuration.selectors';
import { BILLING_CONFIGURATION_TYPES } from 'invision-core/src/components/metadata/billingConfiguration/billing.configuration.action.types';
import { getPreferredTaxDefaultCurrency } from '../../../reducers/helpers/customer.selectors.helpers';
var controllerActions = {
  fetchCodeTypes: fetchCodeTypes,
  fetchCodeTypesThunk: fetchCodeTypesThunk,
  fetchSubtenants: fetchSubtenantMetadata,
  getTaxAssociationCodes: MetadataActions.billingConfiguration.getTaxAssociationCodes,
  searchSubtenants: searchSubtenants,
  setCustomerCategory: setCustomerCategory
};
import moment from 'moment';
var CustomerInformationSectionController = /*#__PURE__*/function () {
  function CustomerInformationSectionController($ngRedux, uiNotificationService) {
    _classCallCheck(this, CustomerInformationSectionController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      AcceptingFor: ACCEPTING_FOR,
      ConsentTypes: CONSENT_TYPES,
      CoreLocaleKeys: CoreLocaleKeys,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      CustomerCategory: CUSTOMER_CATEGORY,
      lastCountry: null,
      chargeTypesForDetailedTaxation: taxModelHelper.getChargeTypesForDetailedTaxation(),
      numberOfRequiredIdentifications: 0,
      onTaxTypeAndLevelSelectorChanged: this.onTaxTypeAndLevelSelectorChanged.bind(this),
      selectedTaxLevelExemptions: [],
      setSubtenantOptions: this.setSubtenantOptions.bind(this),
      shouldShowSubtenant: this.shouldShowSubtenant.bind(this),
      taxLevelExemptionsList: taxModelHelper.taxLevelExemptions(),
      uiNotificationService: uiNotificationService,
      validateNumbers: validateNumbers
    });
  }
  return _createClass(CustomerInformationSectionController, [{
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.taxCategoryExemptions) {
        this.updateTaxCategoryExemptions(this.taxCategoryExemptions);
      }
      if (changesObj.isGdprCompliant || changesObj.minimumAgeCountries) {
        if (this.isGdprCompliant && this.minimumAgeCountries.length > 0) {
          this.updateMinimumAgeByCountry();
        }
      }
      if (changesObj.formattedIdentities && changesObj.formattedIdentities.currentValue !== changesObj.formattedIdentities.previousValue) {
        this.mutatedFormattedIdentities = clone(this.formattedIdentities);
      }
      if (this.requirements.enable_preferred_tax_reporting_currency && (changesObj.customerModel || changesObj.defaultPreferredReportingTaxValues)) {
        var homeCountry = changesObj.customerModel ? changesObj.customerModel.currentValue.HomeCountry : this.customerModel.HomeCountry;
        if (this.defaultPreferredReportingTaxValues.length && !this.customerModel.Id) {
          var defaultCurrency = getPreferredTaxDefaultCurrency(this.defaultPreferredReportingTaxValues, homeCountry);
          if (homeCountry && defaultCurrency && !this.customerModel.PreferredTaxReportingCurrency) {
            this.customerModel.PreferredTaxReportingCurrency = defaultCurrency;
          }
          if (changesObj.customerModel && changesObj.customerModel.previousValue && this.lastCountry !== homeCountry && (!defaultCurrency || defaultCurrency !== this.customerModel.PreferredTaxReportingCurrency) && this.customerModel.PreferredTaxReportingCurrency) {
            this.customerModel.PreferredTaxReportingCurrency = defaultCurrency;
          }
          this.lastCountry = homeCountry;
        }
      }
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addressStates: StatesByCountrySelector(store),
          allCountries: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.AllCountry, store),
          allCountriesLoaded: MetadataCodeLoadedSelector(CODES.AllCountry, store),
          allCountryCurrencies: MetadataCodeTypeSelector(CODES.CountryCurrency, store),
          contactMapping: MetadataCodeTypeSelector(CODES.ContactMapping, store),
          contactMappingLoaded: MetadataCodeLoadedSelector(CODES.ContactMapping, store),
          contactMethodOptions: ContactMethodOptionsSelector(store),
          contactMethods: MetadataCodeTypeSelector(CODES.ContactMethod, store),
          contactMethodsLoaded: MetadataCodeLoadedSelector(CODES.ContactMethod, store),
          countryCurrencies: CreateCountryCurrencyValueOptions(store),
          currenciesLoaded: MetadataCodeLoadedSelector(CODES.Currency, store),
          countryCurrenciesLoaded: MetadataCodeLoadedSelector(CODES.CountryCurrency, store),
          createCustomer: CreateEditCustomerSelector(store),
          currentBusinessUnit: CurrentBusinessUnitSelector(store),
          currentBusinessUnitHasSubtenants: CurrentBusinessUnitHasSubtenants(store),
          currentStep: CurrentStepSelector(store),
          currentSubtenants: ActiveSubtenantsSelector(store),
          createdCustomer: CreatedCustomerSelector(store),
          customerCategory: SelectedCustomerCategorySelector(store),
          customerTypeFilteredOptions: CustomerTypeFilteredSelector(store, _this.isNewCustomer || false),
          defaultCountryCurrency: DefaultCountryCurrencySelector(store),
          defaultCustomerType: DefaultCustomerTypeSelector(store),
          hasConvergentBillerId: HasConvergentBillerIdSelector(store),
          homeCountries: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.AddressCountry, store),
          homeCountriesLoaded: MetadataCodeLoadedSelector(CODES.AddressCountry, store),
          homeCountriesStates: HomeCountriesStatesSelector(store),
          homeCountriesStatesLoaded: MetadataCodeLoadedSelector(CODES.AddressStateProvinceRegion, store),
          invoiceDetailLevelOptions: MetadataCodeTypeSelector(CODES.InvoiceDetailLevel, store),
          isDateOfBirthRequired: SelectedCustomerIsDateOfBirthRequired(store),
          isDbss: IsDbss(store),
          isEditCustomerHierarchyRootOrNotInHierarchy: IsEditCustomerHierarchyRootOrNotInHierarchySelector(store),
          isSubtenantsLoaded: SubtenantsLoadedSelector(store),
          isTaxTypeAssociationCodeLoaded: BillingConfigurationLoadedSelector(BILLING_CONFIGURATION_TYPES.TAX_ASSOCICATION_CODE, store),
          languages: LanguagesForCurrentBusinessUnitSelector(store),
          personGenderOptions: MetadataOptionsForCodeValuesSelector(CODES.PersonGender, store),
          personRaceOptions: MetadataOptionsForCodeValuesSelector(CODES.PersonRace, store),
          personSuffixOptions: MetadataOptionsForCodeValuesSelector(CODES.PersonSuffix, store),
          personTitleOptions: MetadataOptionsForCodeValuesSelector(CODES.PersonTitle, store),
          regularExpressionLoaded: MetadataCodeLoadedSelector(CODES.RegularExpression, store),
          preferredTaxReportingCurrencyConfigLoaded: MetadataCodeLoadedSelector(CODES.DefaultPreferredTaxReportingCurrencyConfig, store),
          selectedCustomerHomeCountry: SelectedCustomerHomeCountrySelector(store),
          subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberIdentifications: SubscriberIdentificationsSelector(store),
          subscriberIdentificationsLoaded: MetadataCodeLoadedSelector(CODES.SubscriberIdentifications, store),
          subscriberIncomeLevelTypeOptions: MetadataOptionsForCodeValuesSelector(CODES.SubscriberIncomeLevelType, store),
          subscriberLeadSourceTypeOptions: MetadataOptionsForCodeValuesSelector(CODES.SubscriberLeadSourceType, store),
          subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberTypeCodes: SubscriberTypeFilterByUserRole(store),
          subscriberTypeSecurityRoleLoaded: MetadataCodeLoadedSelector(CODES.SubscriberTypeSecurityRole, store),
          subscriberValidationTypesLoaded: MetadataCodeLoadedSelector(CODES.SubscriberValidationTypes, store),
          subtenantOptions: SubtenantOptionsSelector(store),
          taxAssociationCodes: TaxAssociationCodesSelector(store),
          taxExemptionTypes: TaxExemptionTypeCodesSelector(store),
          taxLevelCodes: TaxLevelCodesSelector(store),
          language: SessionSelectors.LanguageHeaderSelector(store)
        };
      };
      this.maxEffectiveStartDate = moment(new Date());
      this.defaultEffectiveStartDate = new Date();
      this.isHierarchyParentSubscriberDisabled = this.customerModel.HierarchyParentSubscriberId;
      this.taxExemptionTypesEditValues = [];
      if (this.customerModel.TaxExemptionTypes) {
        this.customerModel.TaxExemptionTypes.forEach(function (taxExemptionTypesVal, index) {
          _this.taxExemptionTypesEditValues.push({
            taxLevelCode: {
              Id: taxExemptionTypesVal.TaxLevelCode.toString()
            },
            taxExemptionType: {
              Id: taxExemptionTypesVal.TaxType
            }
          });
          if (taxExemptionTypesVal.TaxAssociationCode) {
            _this.taxExemptionTypesEditValues[index].taxAssociationCode = {
              Id: taxExemptionTypesVal.TaxAssociationCode
            };
          } else if (!taxExemptionTypesVal.TaxAssociationCode) {
            _this.taxExemptionTypesEditValues[index].taxAssociationCode = null;
          }
          if (taxExemptionTypesVal.State) {
            _this.taxExemptionTypesEditValues[index].addressStateProvinceRegionCode = {
              Id: taxExemptionTypesVal.State
            };
          } else if (!taxExemptionTypesVal.State) {
            _this.taxExemptionTypesEditValues[index].addressStateProvinceRegionCode = null;
          }
          if (taxExemptionTypesVal.OverridePercentage !== null) {
            _this.taxExemptionTypesEditValues[index].overrideValue = taxExemptionTypesVal.OverridePercentage;
          }
        });
      }
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (this.state.isDbss) {
        this.countryLabel = i18n.translate(CustomerCareLocaleKeys.COUNTRY);
      } else {
        this.countryLabel = i18n.translate(CustomerCareLocaleKeys.HOME_COUNTRY);
      }
      if (this.state.isDbss && !this.state.isTaxTypeAssociationCodeLoaded) {
        this.actions.getTaxAssociationCodes();
      }
      if (!this.state.homeCountriesLoaded) {
        this.actions.fetchCodeTypes(CODES.AddressCountry).then(function () {
          _this.checkHomeCountry();
        });
      } else {
        this.checkHomeCountry();
      }
      if (!this.state.allCountriesLoaded) {
        this.actions.fetchCodeTypes(CODES.AllCountry);
      }
      if (this.isEditingProfile() && this.state.isDbss) {
        this.actions.setCustomerCategory(this.customerModel.Category);
      } else if (!this.customerModel.SubscriberTypeCode && !this.isEditingProfile()) {
        this.customerModel.SubscriberTypeCode = this.state.defaultCustomerType;
      }
      this.customerModel.PreferredTaxReportingCurrency = this.customerModel.PreferredTaxReportingCurrency || null;
      this.customerModel.Language = this.customerModel.Language ? this.customerModel.Language : this.state.currentBusinessUnit.defaultLanguage;
      this.updateMinimumAgeByCountry();
      this.selectedTaxLevelExemptions = this.isNewCustomer && !this.customerModel.TaxExemption ? [] : this.taxLevelExemptions.slice(0);
      this.lockedCountry = this.customerModel.HomeCountry;
      if (!this.state.contactMethodsLoaded) {
        this.actions.fetchCodeTypes(CODES.ContactMethod);
      }
      if (!this.state.preferredTaxReportingCurrencyConfigLoaded) {
        this.actions.fetchCodeTypes(CODES.DefaultPreferredTaxReportingCurrencyConfig);
      }
      if (!this.state.contactMappingLoaded) {
        this.actions.fetchCodeTypes(CODES.ContactMapping);
      }
      if (!this.state.subscriberTypeSecurityRoleLoaded) {
        this.actions.fetchCodeTypes(CODES.SubscriberTypeSecurityRole);
      }
      if (!this.state.currenciesLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.Currency);
      }
      if (!this.state.countryCurrenciesLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.CountryCurrency).then(function () {
          _this.triggerFormChange();
        });
      } else {
        this.triggerFormChange();
      }
      this.actions.searchSubtenants().then(function () {
        _this.setSubtenantOptions();
      }).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      });
      if (!this.state.subscriberIdentificationsLoaded) {
        this.actions.fetchCodeTypes(CODES.SubscriberIdentifications);
      }
      if (!this.state.subscriberValidationTypesLoaded) {
        this.actions.fetchCodeTypes(CODES.SubscriberValidationTypes);
      }
      if (!this.state.regularExpressionLoaded) {
        this.actions.fetchCodeTypes(CODES.RegularExpression);
      }
      if (!this.state.homeCountriesStatesLoaded) {
        this.actions.fetchCodeTypes(CODES.AddressStateProvinceRegion);
      }
      this.isCountryDisabled = this.isNewConnect || !this.isNewCustomer && this.state.hasConvergentBillerId;
      this.handleConsentFormChanged = function () {
        _this.onFormChanged()(_this.customerModel);
      };
      this.externalReferenceId = this.customerModel.ExternalReference;
    }
  }, {
    key: "canDisplayConsentFields",
    get: function get() {
      return this.mandatoryConsents.length > 0;
    }
  }, {
    key: "requirements",
    get: function get() {
      if (this.state) {
        return this.state.customerCategory === CUSTOMER_CATEGORY.COMMERCIAL ? this.state.subscriberCategoryRequirements : this.state.subscriberRequirements;
      } else {
        return {};
      }
    }
  }, {
    key: "triggerFormChange",
    value: function triggerFormChange() {
      if (this.state.isDbss && !this.isNewConnect) {
        this.handleChangeFormCountry();
      } else {
        this.handleFormChanged();
      }
    }
  }, {
    key: "getLanguageFriendlyName",
    value: function getLanguageFriendlyName() {
      var langObj = find(propEq(this.customerModel.Language, 'value'), this.state.languages);
      return langObj ? langObj.label : this.customerModel.Language;
    }
  }, {
    key: "getSubtenantName",
    value: function getSubtenantName() {
      var _this2 = this;
      if (this.customerModel.SubtenantId) {
        var subtenant = this.state.currentSubtenants.find(function (subtenant) {
          return subtenant.Id.Value === _this2.customerModel.SubtenantId.Value;
        });
        return subtenant ? subtenant.Name : i18n.translate(this.CoreLocaleKeys.NOT_APPLICABLE);
      } else {
        return i18n.translate(this.CoreLocaleKeys.NOT_APPLICABLE);
      }
    }
  }, {
    key: "setSubtenantOptions",
    value: function setSubtenantOptions() {
      var _this3 = this;
      if (!this.selectedCustomerSubtenant) {
        this.subtenantOptions = this.state.subtenantOptions;
      } else {
        this.subtenantOptions = this.selectedCustomerSubtenant !== NO_SUBTENANTS ? this.state.subtenantOptions.filter(function (subtenant) {
          return _this3.selectedCustomerSubtenant === subtenant.value;
        }) : [];
      }
    }
  }, {
    key: "shouldShowSubtenant",
    value: function shouldShowSubtenant() {
      return this.state.currentBusinessUnitHasSubtenants && !this.isNewConnect && this.requirements.display_subtenant && this.subtenantOptions && this.subtenantOptions.length;
    }
  }, {
    key: "handleAcceptingForChanged",
    value: function handleAcceptingForChanged() {
      this.customerModel.IsMinor = this.customerModel.ConsentAcceptingFor === this.AcceptingFor.CHILD;
      this.updateMinimumAgeByCountry();
      this.updateMinimumAgeByAcceptingFor();
      this.handleFormChanged();
    }
  }, {
    key: "handleChangeFormCountry",
    value: function handleChangeFormCountry() {
      if (this.isGdprCompliant) {
        this.updateMinimumAgeByCountry();
        this.updateMinimumAgeByAcceptingFor();
        if (this.isNewCustomer) {
          this.customerModel.ConsentAcceptingMandatoryTerms.IsAccepted = false;
        } else if (this.customerModel.ConsentAcceptingMandatoryTerms) {
          this.customerModel.ConsentAcceptingMandatoryTerms.IsAccepted = this.customerModel.HomeCountry === this.state.selectedCustomerHomeCountry;
        }
      }
      if (this.state.isDbss) {
        if (this.isCurrencyDisabled && !this.isCountryChangeAllowed()) {
          this.customerModel.HomeCountry = this.lockedCountry;
          this.handleFormChanged();
          this.uiNotificationService.error(i18n.translate(CustomerCareLocaleKeys.CURRENCY_NOT_SUPPORTED), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        } else {
          this.handleFormChanged();
          this.updateCountryCurrencies();
        }
      } else {
        this.handleFormChanged();
      }
    }
  }, {
    key: "handleChangeForExternalReference",
    value: function handleChangeForExternalReference() {
      if (!!this.customerModel.ExternalReference && !this.externalReferenceId) {
        this.parentForm.externalId.$setValidity('emptyId', false);
      } else {
        this.parentForm.externalId.$setValidity('emptyId', true);
        this.customerModel.ExternalReference = this.externalReferenceId;
        this.handleFormChanged();
      }
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "updateCountryCurrencies",
    value: function updateCountryCurrencies() {
      if (this.state.countryCurrencies) {
        this.updateCountryCurrencyField();
      } else {
        this.uiNotificationService.error(i18n.translate(CustomerCareLocaleKeys.CURRENCY_NOT_FOUND), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }
    }
  }, {
    key: "isCountryChangeAllowed",
    value: function isCountryChangeAllowed() {
      var _this4 = this;
      var currencies = this.state.allCountryCurrencies.filter(function (currency) {
        return currency.AdditionalProperties.find(propEq('country', 'Key')).Value === _this4.customerModel.HomeCountry && currency.AdditionalProperties.find(propEq('currency', 'Key')).Value === _this4.customerModel.SubscriberCurrency;
      });
      return currencies.length;
    }
  }, {
    key: "updateMinimumAgeByAcceptingFor",
    value: function updateMinimumAgeByAcceptingFor() {
      if (this.customerModel.ConsentAcceptingFor === this.AcceptingFor.CHILD) {
        var today = new Date();
        this.maximumAgeDate = today;
        this.setNewErrorLookup(today);
      }
    }
  }, {
    key: "updateMinimumAgeByCountry",
    value: function updateMinimumAgeByCountry() {
      if (this.customerModel.IsMinor) {
        // IsMinor would be returned as part of the API Response in RetrieveSubscriber (DD-43048).
        var today = new Date();
        this.maximumAgeDate = today;
        this.setNewErrorLookup(today);
      } else {
        var matchingCountry = this.getMatchingSelectedCountry(this.customerModel.HomeCountry);
        if (matchingCountry) {
          this.setMinimumAgeFromCountry(matchingCountry);
        } else if (pathOr(null, ['minimum_age'], this.requirements)) {
          this.setMinimumAgeFromDefault(); // As per settings on SL
        } else {
          var _matchingCountry = this.getMatchingSelectedCountry('');
          if (_matchingCountry) {
            this.setMinimumAgeFromCountry(_matchingCountry);
          }
        }
      }
    }
  }, {
    key: "getMatchingSelectedCountry",
    value: function getMatchingSelectedCountry(countryCode) {
      return this.minimumAgeCountries.find(function (codeCountry) {
        var countryValue = codeCountry.AdditionalProperties.find(function (countryProp) {
          return countryProp.Key === 'country';
        }).Value;
        return countryValue === countryCode;
      });
    }
  }, {
    key: "setMinimumAgeFromCountry",
    value: function setMinimumAgeFromCountry(matchingCountry) {
      var minimumAge = matchingCountry.AdditionalProperties.find(function (additionalProperty) {
        return additionalProperty.Key === 'age';
      }).Value;
      var maximumAgeDate = new Date();
      maximumAgeDate.setFullYear(maximumAgeDate.getFullYear() - minimumAge);
      this.maximumAgeDate = maximumAgeDate;
      this.setNewErrorLookup(minimumAge);
    }
  }, {
    key: "setMinimumAgeFromDefault",
    value: function setMinimumAgeFromDefault() {
      this.maximumAgeDate = this.requirements.minimum_age_birthdate;
      this.setNewErrorLookup(this.requirements.minimum_age);
    }
  }, {
    key: "setNewErrorLookup",
    value: function setNewErrorLookup(minAge) {
      if (pathOr(null, ['subscriberRequirements', 'maximum_age'], this.state)) {
        this.errorLookup = getErrorLookupObject({
          birthDate: {
            outOfRange: {
              maxAge: this.state.subscriberRequirements.maximum_age,
              minAge: minAge
            }
          }
        });
      }
    }
  }, {
    key: "updateCountryCurrencyField",
    value: function updateCountryCurrencyField() {
      if (this.state.countryCurrencies) {
        if (this.isNewCustomer) {
          var _this$state$defaultCo;
          this.customerModel.SubscriberCurrency = ((_this$state$defaultCo = this.state.defaultCountryCurrency) === null || _this$state$defaultCo === void 0 ? void 0 : _this$state$defaultCo.Value) || this.state.countryCurrencies[0].value;
        } else {
          var _this$state$defaultCo2, _this$state$countryCu;
          this.customerModel.SubscriberCurrency = this.state.createCustomer.SubscriberCurrency || ((_this$state$defaultCo2 = this.state.defaultCountryCurrency) === null || _this$state$defaultCo2 === void 0 ? void 0 : _this$state$defaultCo2.Value) || ((_this$state$countryCu = this.state.countryCurrencies[0]) === null || _this$state$countryCu === void 0 ? void 0 : _this$state$countryCu.value);
        }
      }
      this.handleFormChanged();
    }
  }, {
    key: "isError",
    value: function isError(elementName) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var formElement = this.parentForm[elementName];
      var isError = false;
      if (formElement && (formElement.$touched || this.isFormSubmitted)) {
        if (fields.length === 0 && Object.keys(formElement.$error).length > 0) {
          isError = true;
        }
        fields.forEach(function (field) {
          if (formElement.$error[field]) {
            isError = true;
          }
        });
      }
      return isError;
    }
  }, {
    key: "onSelectedTaxLevelExemptionsChanged",
    value: function onSelectedTaxLevelExemptionsChanged() {
      this.customerModel.TaxExemption = taxModelHelper.createTaxExemptionFromOptions(this.selectedTaxLevelExemptions, this.customerModel);
      this.handleFormChanged();
    }
  }, {
    key: "onTaxTypeAndLevelSelectorChanged",
    value: function onTaxTypeAndLevelSelectorChanged() {
      if (this.taxExemptionTypesEditValues && this.taxExemptionTypesEditValues.length > 0) {
        this.customerModel.TaxExemptionTypes = this.formatTaxExemptionDataForServer(this.taxExemptionTypesEditValues);
      } else {
        this.customerModel.TaxExemptionTypes = [];
      }
      this.handleFormChanged();
    }
  }, {
    key: "onSubtenantChanged",
    value: function onSubtenantChanged() {
      if (!this.customerModel.SubtenantId.Value) {
        this.customerModel.SubtenantId = null;
      }
      this.handleFormChanged();
    }
  }, {
    key: "formatTaxExemptionDataForServer",
    value: function formatTaxExemptionDataForServer(taxExemptionTypesEditValues) {
      var taxExemptionTypes = [];
      taxExemptionTypesEditValues.forEach(function (taxExemptionTypesEditValue) {
        if (taxExemptionTypesEditValue.taxLevelCode && taxExemptionTypesEditValue.taxExemptionType) {
          taxExemptionTypes.push({
            TaxLevelCode: convertStringToNumber(taxExemptionTypesEditValue.taxLevelCode.Id),
            TaxType: taxExemptionTypesEditValue.taxExemptionType.Id,
            TaxAssociationCode: taxExemptionTypesEditValue.taxAssociationCode ? taxExemptionTypesEditValue.taxAssociationCode.Id : null,
            State: taxExemptionTypesEditValue.addressStateProvinceRegionCode ? taxExemptionTypesEditValue.addressStateProvinceRegionCode.Id : null,
            OverridePercentage: taxExemptionTypesEditValue.overrideValue
          });
        }
      });
      return taxExemptionTypes;
    }
  }, {
    key: "synchronizeMultiSelectOptions",
    value: function synchronizeMultiSelectOptions(options, items) {
      var propertyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      return options.map(function (option) {
        var selectedItemExists = find(propEq(option[propertyName], propertyName))(items);
        if (selectedItemExists) {
          option.selected = selectedItemExists.selected;
        } else if (option.selected) {
          option.selected = !option.selected;
        }
        return option;
      });
    }
  }, {
    key: "updateTaxCategoryExemptions",
    value: function updateTaxCategoryExemptions(taxCategoryExemptions) {
      this.taxCategoryExemptionsOptions = clone(taxCategoryExemptions);
      if (this.alreadyExistingCustomer() && this.hasSelectedTaxCategoryExemptions()) {
        this.setSelectedTaxCategories(this.customerSelectedTaxCategoryExemptions);
      } else if (this.temporaryPersistedCustomer()) {
        this.setSelectedTaxCategories(this.customerModel.TaxExemptionCategories);
      }
    }
  }, {
    key: "alreadyExistingCustomer",
    value: function alreadyExistingCustomer() {
      return !this.isNewCustomer;
    }
  }, {
    key: "hasSelectedTaxCategoryExemptions",
    value: function hasSelectedTaxCategoryExemptions() {
      return this.customerSelectedTaxCategoryExemptions.length > 0;
    }
  }, {
    key: "temporaryPersistedCustomer",
    value: function temporaryPersistedCustomer() {
      return !!this.customerModel.TaxExemptionCategories;
    }
  }, {
    key: "setSelectedTaxCategories",
    value: function setSelectedTaxCategories(selectedTaxCategoryExemptions) {
      this.taxCategoryExemptionsOptions.forEach(function (item) {
        item.selected = selectedTaxCategoryExemptions.some(function (exemption) {
          return exemption === item.id;
        });
      });
    }
  }, {
    key: "shouldShowTaxTypeAndLevelSelector",
    value: function shouldShowTaxTypeAndLevelSelector() {
      return !!(this.state.taxExemptionTypes.length && this.state.taxLevelCodes.length);
    }
  }, {
    key: "isEditingProfile",
    value: function isEditingProfile() {
      return !!this.state.createCustomer.Id;
    }
  }, {
    key: "isEditingInDbss",
    value: function isEditingInDbss() {
      return this.state.isDbss && this.isEditingProfile();
    }
  }, {
    key: "selectedCountryName",
    value: function selectedCountryName() {
      var _this5 = this;
      var selectedCountry = this.state.homeCountries.find(function (country) {
        return country.value === _this5.customerModel.HomeCountry;
      });
      return pathOr(this.customerModel.HomeCountry, ['label'], selectedCountry);
    }
  }, {
    key: "selectedCurrencyName",
    value: function selectedCurrencyName() {
      var _this6 = this;
      var selectedCurrency = this.state.countryCurrencies && this.state.countryCurrencies.find(function (currency) {
        return currency.value === _this6.customerModel.SubscriberCurrency;
      });
      return pathOr(this.customerModel.SubscriberCurrency, ['label'], selectedCurrency);
    }
  }, {
    key: "checkHomeCountry",
    value: function checkHomeCountry() {
      var _this7 = this;
      if (!this.customerModel.HomeCountry || !this.state.homeCountries.find(function (country) {
        return country.value === _this7.customerModel.HomeCountry;
      })) {
        this.customerModel.HomeCountry = this.state.currentBusinessUnit.defaultCountry;
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "isIdentificationRequired",
    value: function isIdentificationRequired(index) {
      return index < this.mutatedFormattedIdentities.numberOfRequiredIdentifications;
    }
  }, {
    key: "getCountries",
    value: function getCountries(customerSubscriberIdentification) {
      var result = this.customerModel.SubscriberIdentifications.find(function (subscriberIdentification) {
        return subscriberIdentification.SubscriberIdentificationTypeCode === customerSubscriberIdentification.SubscriberIdentificationTypeCode;
      });
      return customerSubscriberIdentification.UseConfiguredCountries ? result ? customerSubscriberIdentification.Countries : this.state.homeCountries : this.state.allCountries;
    }
  }, {
    key: "beforeHandleUpdateIdentification",
    value: function beforeHandleUpdateIdentification(customerSubscriberIdentification) {
      var selectedSubscriberIdentification = this.state.subscriberIdentifications.find(function (subscriberIdentification) {
        return subscriberIdentification.Value === customerSubscriberIdentification.SubscriberIdentificationTypeCode;
      });
      customerSubscriberIdentification.Countries = selectedSubscriberIdentification ? selectedSubscriberIdentification.Countries : null;
      customerSubscriberIdentification.IsPrimary = selectedSubscriberIdentification ? selectedSubscriberIdentification.IsPrimary : null;
      customerSubscriberIdentification.IsCountryStateRequired = selectedSubscriberIdentification ? selectedSubscriberIdentification.IsCountryStateRequired : null;
      customerSubscriberIdentification.IsCountryStateVisible = selectedSubscriberIdentification ? selectedSubscriberIdentification.IsCountryStateVisible : null;
      customerSubscriberIdentification.Regex = selectedSubscriberIdentification ? selectedSubscriberIdentification.Regex : null;
      customerSubscriberIdentification.UseConfiguredCountries = selectedSubscriberIdentification ? selectedSubscriberIdentification.UseConfiguredCountries : null;
      this.handleIdentificationChanged();
    }
  }, {
    key: "handleCountryChanged",
    value: function handleCountryChanged(subscriberIdentification) {
      subscriberIdentification.State = null;
      this.handleIdentificationChanged();
    }
  }, {
    key: "handleIdentificationChanged",
    value: function handleIdentificationChanged() {
      this.customerModel.SubscriberIdentifications = this.mutatedFormattedIdentities.formattedSubscriberIdentifications.map(function (subIdentification) {
        return {
          Country: subIdentification.Country,
          Id: subIdentification.Id || null,
          State: subIdentification.State,
          SubscriberIdentificationTypeCode: subIdentification.SubscriberIdentificationTypeCode,
          SubscriberIdentificationValue: subIdentification.SubscriberIdentificationValue
        };
      }).filter(function (subIdentification) {
        return subIdentification.SubscriberIdentificationTypeCode || subIdentification.SubscriberIdentificationValue;
      });
      this.handleFormChanged();
    }
  }, {
    key: "addIdentityVerification",
    value: function addIdentityVerification() {
      this.mutatedFormattedIdentities.formattedSubscriberIdentifications.push({
        IsCountryStateRequired: false,
        IsCountryStateVisible: false,
        IsPrimary: false,
        Regex: null,
        SubscriberIdentificationTypeCode: null,
        SubscriberIdentificationValue: null,
        UseConfiguredCountries: null
      });
    }
  }, {
    key: "removeIdentityVerification",
    value: function removeIdentityVerification(index) {
      this.mutatedFormattedIdentities.formattedSubscriberIdentifications.splice(index, 1);
      this.handleIdentificationChanged();
    }
  }, {
    key: "filterIdentifications",
    value: function filterIdentifications(index, subscriberIdentificationId) {
      var _this8 = this;
      return function (option) {
        if (!option.Value || option.Value === subscriberIdentificationId) {
          return true;
        }
        if (index === 0 && !option.IsPrimary) {
          return false;
        } else {
          // Don't show an option which was already selected in another dropdown.
          for (var itemIndex = 0; itemIndex < _this8.mutatedFormattedIdentities.formattedSubscriberIdentifications.length; itemIndex++) {
            if (itemIndex !== index && option.Value === _this8.mutatedFormattedIdentities.formattedSubscriberIdentifications[itemIndex].SubscriberIdentificationTypeCode) {
              return false;
            }
          }
        }
        return true;
      };
    }
  }, {
    key: "identificationsExists",
    value: function identificationsExists() {
      return this.state.subscriberIdentifications && this.state.subscriberIdentifications.length;
    }
  }, {
    key: "getRegexPattern",
    value: function getRegexPattern(subscriberIdentification, elementName) {
      if (this.isEditingProfile()) {
        return this.parentForm[elementName].$dirty ? subscriberIdentification.Regex : null;
      } else {
        return subscriberIdentification.Regex;
      }
    }
  }, {
    key: "onEffectiveStartDateChanged",
    value: function onEffectiveStartDateChanged() {
      var effectiveStartDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
      this.customerModel.EffectiveStartDate = moment(effectiveStartDate).toDate();
      this.handleFormChanged();
    }
  }, {
    key: "isRequired",
    get: function get() {
      return this.removeMultiOfferValidations !== undefined ? !this.removeMultiOfferValidations : !this.overrideValidations;
    }
  }, {
    key: "isRequiredForGDPRAndLiteCustomer",
    get: function get() {
      return this.canDisplayConsentFields && this.overrideValidations || this.removeMultiOfferValidations !== undefined && this.canDisplayConsentFields;
    }
  }]);
}();
export default {
  template: require('./customer.information.section.html'),
  bindings: {
    customerModel: '<',
    customerPreferredTaxCurrencies: '<',
    customerSelectedTaxCategoryExemptions: '<',
    defaultPreferredReportingTaxValues: '<',
    errorLookup: '<',
    formattedIdentities: '<',
    isCurrencyDisabled: '<',
    isCustomerTypeReadOnly: '<',
    isEffectiveStartDateReadOnly: '<',
    isFormSubmitted: '<',
    isGdprCompliant: '<',
    isHierarchyParentSubscriberDisabled: '<?',
    isMandatoryConsentsToBeAccepted: '<',
    isNewConnect: '<?',
    isNewCustomer: '<',
    isParentNodeDisabled: '<?',
    mandatoryConsents: '<',
    markMandatoryCreditCheckFieldsDisabled: '<?',
    minimumAgeCountries: '<',
    onFormChanged: '&',
    overrideValidations: '<?',
    removeMultiOfferValidations: '<?',
    selectedCustomerSubtenant: '<',
    taxCategoryExemptions: '<',
    taxLevelExemptions: '<'
  },
  require: {
    parentForm: '^form'
  },
  controller: CustomerInformationSectionController,
  controllerAs: 'CustomerInformationSection'
};